<script>
export default {
  props: {
    height: {
      type: Number,
      required: false,
      default: 200
    }
  }
}
</script>

<template>
<div class="dashboard-no-data"  :style="{height: height+'px'}">
  {{$t('label_dashboard_no_data')}}
</div>
</template>

<style scoped lang="scss">
.dashboard-no-data {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

}
</style>
